"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.brand = void 0;
var qs = require('qs');
exports.brand = function (axios) {
    return {
        /** 적용가능한 브랜드 목록 조회 */
        getBrands: function (request) {
            return axios.get('/brands', request);
        },
        /** 브랜드 생성 */
        postBrands: function (request) {
            return axios.post('/brands', request.data);
        },
        /** 브랜드 목록 검색 */
        getBrandsSearch: function (request) {
            return axios.get('/brands/search', request);
        },
        /** 브랜드 수정 */
        putBrandsBrandNo: function (request) {
            return axios.put("/brands/" + request.pathParams.brandNo, request.data);
        },
        /** 브랜드 삭제 */
        deleteBrandsBrandNo: function (request) {
            var query = qs.stringify(request.params);
            return axios.delete("/brands/" + request.pathParams.brandNo + "?" + query, request.data);
        },
        /** 몰별 브랜드 조회 */
        getBrandsView: function (request) {
            return axios.get('/brands/view', request);
        },
        /** 브랜드 트리 조회 */
        getBrandsTree: function (request) {
            return axios.get('/brands/tree', request);
        },
        /** 브랜드 상세 조회 */
        getBrandsBrandNo: function (request) {
            return axios.get("/brands/" + request.pathParams.brandNo, request);
        },
        /** 브랜드 중복 조회 */
        getBrandsDuplicate: function (request) {
            return axios.get('/brands/duplicate', request);
        },
        /** 브랜드 상품 개수 조회 */
        getBrandsProductCount: function (request) {
            return axios.get('/brands/product-count', request);
        }
    };
};
